import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DocumentViewModel } from 'src/app/modules/shared/viewModels/documents/documentViewModel';
import { UploadViewModel } from 'src/app/modules/shared/viewModels/documents/uploadViewModel';

@Component({
    selector: 'app-attachments-board-view',
    templateUrl: 'attachments-board-view.component.html',
    styleUrls: ['attachments-board-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AttachmentsBoardViewComponent {
  @Input() accountId: number;
  @Input() documents: DocumentViewModel[];
  @Input() uploadViewModel: UploadViewModel;
  @Input() contextualInfo: any;
  @Input() documentContextualInfoMapping: Map<number, any>;

  @Output() onAttachmentDownload = new EventEmitter<DocumentViewModel>();
  @Output() onAttachmentDelete = new EventEmitter<DocumentViewModel>();
  @Output() onAttachmentLinkClicked = new EventEmitter<DocumentViewModel>();

  attachmentDownload(attachment: DocumentViewModel) {
    this.onAttachmentDownload.next(attachment);
  }

  attachmentDelete(attachment: DocumentViewModel) {
    this.onAttachmentDelete.next(attachment);
  }

  attachmentLinkClicked(attachment: DocumentViewModel) {
    this.onAttachmentLinkClicked.next(attachment);
  }

  getDocumentContextualInfo(document: DocumentViewModel): any {
    if (this.documentContextualInfoMapping && document.id) {
      const contextualInfo = this.documentContextualInfoMapping.get(document.id);
      if (contextualInfo) {
        return contextualInfo;
      }
    }

    return this.contextualInfo;
  }
}
